import { memo } from 'react';
import { useTranslation } from '@aimsos/i18n';
import { Button, CartContainer } from '@aimsos/ui';

import { AlertCircle } from 'lucide-react';

/**
 * "Couldn't load insights · Retry" (CT-5716): one compact row above the chips,
 * as in the prototype. Whatever the grid already showed stays under it.
 */
const InsightsLoadError = memo(function InsightsLoadError({ onRetry }) {
  const { t } = useTranslation('unified-profiles');

  return (
    <div data-testid="insights-load-error" role="alert">
      <CartContainer size="S" variant="neutral">
        <div className="flex items-center justify-between gap-3">
          <p className="flex items-center gap-2 text-sm text-content-secondary">
            <AlertCircle size={16} aria-hidden className="shrink-0" />
            {t('intelligence.insights.loadError.title')}
          </p>
          <Button variant="ghost" size="sm" onClick={onRetry}>
            {t('intelligence.insights.loadError.retry')}
          </Button>
        </div>
      </CartContainer>
    </div>
  );
});

export default InsightsLoadError;
